import { DateUtils } from 'react-day-picker';

const isDayInThePast = (day: Date) => DateUtils.isPastDay(day);

export default isDayInThePast;
